(function () {
  var STORAGE_KEY = 'app-install-banner-dismissed';

  function getPlatform() {
    var ua = navigator.userAgent;

    if (/Android/.test(ua)) {
      return 'android';
    }

    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      // Real mobile Safari already shows Apple's native smart banner via the
      // apple-itunes-app meta tag, so skip our banner there to avoid a
      // duplicate; only show it for other iOS browsers (Chrome/Firefox/etc).
      var isRealSafari = /Version\/[\d.]+.*Safari/.test(ua);
      return isRealSafari ? null : 'ios';
    }

    return null;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var banner = document.getElementById('AppInstallBanner');
    if (!banner) return;

    if (window.localStorage.getItem(STORAGE_KEY)) return;

    var platform = getPlatform();
    if (!platform) return;

    var icon = banner.getAttribute('data-icon');
    var title = banner.getAttribute('data-title');
    var author = banner.getAttribute('data-author');
    var url = platform === 'ios'
      ? banner.getAttribute('data-ios-url')
      : banner.getAttribute('data-android-url');
    var priceLabel = platform === 'ios'
      ? 'FREE - On the App Store'
      : 'FREE - In Google Play';

    banner.querySelector('.app-install-banner__icon').src = icon;
    banner.querySelector('.app-install-banner__title').textContent = title;
    banner.querySelector('.app-install-banner__author').textContent = author;
    banner.querySelector('.app-install-banner__price').textContent = priceLabel;
    banner.querySelector('.app-install-banner__button').href = url;

    banner.hidden = false;

    banner.querySelector('.app-install-banner__close').addEventListener('click', function () {
      banner.hidden = true;
      window.localStorage.setItem(STORAGE_KEY, '1');
    });
  });
})();
